import {
  type Form,
  type FormField,
  type FieldsSettings,
  type MultilineAddress,
} from '@wix/ambassador-forms-v4-form/types';
import { type ValueOf } from './utils';

export function applyViewProperties(rootView: MultilineAddress = {}) {
  return (addressForms: Form) => {
    const fieldSettings = rootView.fieldSettings;
    if (fieldSettings) {
      const modifiedFields = addressForms.fields?.map((field) =>
        field.target
          ? overrideFieldProperties(
              field,
              fieldSettings[field.target as keyof FieldsSettings],
            )
          : field,
      );
      return { ...addressForms, fields: modifiedFields };
    } else {
      return addressForms;
    }
  };
}

function overrideFieldProperties(
  field: FormField,
  settings?: ValueOf<FieldsSettings>,
): FormField {
  if (settings) {
    return {
      ...field,
      hidden: settings.show === undefined ? field.hidden : !settings.show,
    };
  } else {
    return field;
  }
}
